
type ParamCardService = {
    title: string;
    image: string;
    list: any;
  };
  const CardService: React.FC<ParamCardService> = ({ title, image, list }) => {
    return (
      <div className= "mx-auto rounded bg-stone-800 overflow-hidden  border border-stone-800">
        <img className="w-full mx-auto" src={image} alt={title} height="200" />
        <div className="px-2  py-2">
          <div className="font-semibold text-stone-200 text-xs md:text-base ">{title} </div>
          {list}
        </div>
      </div>
    );
  };
  
  export default CardService;
  